module.exports = __webpack_public_path__ + "images/emoji/waxing_crescent_moon.55d4e468a6e555b84228.png";